import styled from '@emotion/styled'

export const DialogContainer = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
`

export const Dialog = styled.div`
  margin-top: -2rem;
  width: 30rem;
  padding: 2rem;
`

export const DialogHeader = styled.h2`
  font-size: 2rem;
  color: ${({ theme }) => theme.onBackground};
`

export const DialogSubtitle = styled.p`
  margin-top: 0.25rem;
  font-size: 1rem;
  color: ${({ theme }) => theme.onBackgroundSemiLight};
`

export const DialogTopTitle = styled.div`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.onBackgroundLight};
  margin-bottom: 1rem;
`
